<template>
<div class="chapter">
<div class="inner_page">
<div>
<div class="chapter" id="fig03">
<div class="figure">
<p class="fig"><a id="pg2"><img alt="" height="600" src="images/eer-kaiulani-fig03.jpg" width="592"/></a></p><a id="pg2">
<p class="figcap">An early view of Honolulu, looking inland. This is the Hawai‘i that Western influence changed forever.</p>
</a></div><a id="pg2">
</a></div><a id="pg2">
</a></div><a id="pg2">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// eer-kaiulani-0013.vue?ece1d03a